// Gate for the mt-edit mode, in its own module so i18n.ts can check it on
// the locale-loading hot path without pulling the whole mt-edit UI.
export function isMtEditEnabled(): boolean {
  try {
    const v = new URLSearchParams(window.location.search).get("mt-edit");
    if (v === "1") {
      sessionStorage.setItem("mt-edit", "1");
    } else if (v === "0") {
      sessionStorage.removeItem("mt-edit");
    }
    return sessionStorage.getItem("mt-edit") === "1";
  } catch {
    return false;
  }
}
